module.exports = __webpack_public_path__ + "static/media/29EUNOG1.6932e0c0.jpg";